import { reactive, ref, computed, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import Vue from 'vue'
import * as common from '@/util/common'
import * as apiQA from '@/api/qa'
import {propagateCheckedRecursively, getCheckedNodeItemTypeAndIds, setNodeCheckByItemTypeAndIds, getCheckedProductIds} from '@/logic/common/CommonQA'
import { searchByKeyword, getSearchText } from '@/util/search'
import * as logicCommonBookList from '@/logic/common/CommonBookList'
import * as _ from 'lodash'

/**
 * 書式ダウンロード一覧画面
 */
export const getGroup = (props, context) => {

  onBeforeMount(() => {
    // 初期表示
    group1.init()
  })

  const group1 = reactive({

    // モード(list: 一覧表示(ドリルダウン)モード、search: キーワード検索モード )
    mode: computed({
      get: () => {
        return store.state.documentDownloadsList.mode
      },
      set: (mode) => {
        store.dispatch('documentDownloadsList/setMode', mode)
      }
    }), 

    // 最後に検索実行したキーワード
    lastSearchedKeyword: '',

    // キーワード検索中判定
    isKeywordSearch: computed(() => {
      return (group1.mode === 'search' && group1.lastSearchedKeyword !== '')
    }),

    // 「検索をクリア」を押せるか？ボタン
    isSearchConditionClearable: computed(() => {
      return (group1.mode === 'search' && (group1.lastSearchedKeyword !== '' || group1.idMapListOfCheckedProducts.length > 0))
    }),

    // ### ヘッダエリア ###
    // キーワード入力欄に入力した文字列
    search_text: computed(() => {
      return getSearchText(group1.searchCategory)
    }),

    // 検索カテゴリ（選択肢）
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    }),

    // ### パッケージ＆商品一覧エリア ###
    packagesAndProductsDataExists: false, // パッケージ＆商品データ存在フラグ

    // 絞り込みエリアのヒット件数表示フラグ
    isSearchCountShown: computed(() => {
      return (group1.mode === 'search' && group1.search_text !== '')
    }),

    // ツリーの各ノートの親ノードの参照を格納するオブジェクト
    parentNodeMap: {},
    // パッケージ＆商品ツリーデータ
    packagesAndProductsAreaTreeData: {},
    // 単体書籍リスト
    packagesAndProductsAreaBooks: [],

    single_books: [], // 単体書籍（データバインディング用）

    // idMapListOfCheckedProducts: [], // チェックされている商品の商品IDと書籍IDのリスト
    // チェックされている商品の商品IDと書籍IDのリスト
    idMapListOfCheckedProducts: computed(() => {
      return store.state.documentDownloadsList.idMapListOfCheckedProducts
    }),

    allIdMapListForProductIdMap: {}, // 商品IDに対する全商品ID&書籍IDリストの対応マップ

    // データロード完了フラグ
    isListPackagesAndProductsLoaded: false,


    // ### 書籍一覧エリア ###
    booksDataExists: false, // 書籍データ存在フラグ

    booksAreaProducts: [],
    booksAreaBooks: [],

    // データロード完了フラグ
    isListBooksLoaded: false,


    // ### 書式DL一覧エリア ###
    documentDownloadsExists: false, // 書式DL一覧ツリーデータ存在フラグ

    documentDownloadsAreaTreeData: {}, // 書式DL一覧ツリーデータ
    
    // 目次を表示中の書籍の種類(package_book=パッケージ商品、single_book=単体書籍)
    currentBookType: '',
    // 目次を表示中のノードID
    currentNodeId: 0,
    // 目次を表示中の書籍のID
    currentBookId: 0,
    // 目次を表示中の書籍名
    currentBookName: '',

    // ### ハイライトキーワード関係 ###  
    // 現在選択中の書籍のハイライトキーワードの開始番号
    matchedStartNo: 0,
    // 現在選択中の書籍のハイライトキーワードの終了番号
    matchedEndNo: 0,
    // 現在選択中のハイライトキーワードの番号
    matchedCurrentNo: 0,
    // ヒットしたキーワードの総合計
    matchedTotal: 0,

    // 現在選択中のハイライトキーワードの番号(画面表示用)
    matchedCurrentNo4Disp: computed(() => {
      return common.breakComma(group1.matchedCurrentNo)
    }),
    // ヒットしたキーワードの総合計(画面表示用)
    matchedTotal4Disp: computed(() => {
      return common.breakComma(group1.matchedTotal)
    }),
    isMatchedTotalLoaded: false, // データ件数ロード完了フラグ

    // データロード完了フラグ
    isListBooksAndFormDownloadsLoaded: false,


    /**
     * 初期表示
     */
    init: () => {

      // 検索カテゴリを設定
      store.dispatch('search/setSearchCategory', 'download')

      if (typeof store.state.search.download !== 'undefined' && Object.keys(store.state.search.download).length > 0) {
        // 検索条件が設定されている場合（ダッシュボード、メニュー、保存検索条件画面、検索履歴画面などから来た場合）

        // 検索
        group1.searchWithOptions({ is_init: true })

      } else if (group1.search_text !== '') {
        // ダッシュボードやメニューでキーワードを入力し、
        // 検索ボタンではなく、メニューの「書式ダウンロード」ボタンを押して遷移してきた場合、
        // キーワード入力欄にあるテキストで検索を実行する

        // group1.search_text と group1.is_fuzzy はすでにフォームに設定されているため、ここで設定しない。
        // メニューには絞り込みがないため、絞り込みの復元はしない。

        // 検索
        group1.searchWithOptions({ is_init: true })

      } else {
        // 検索条件が設定されていない場合

        // パッケージ・商品一覧エリアを表示
        group1.updatePackageAndProductsArea(true)
      }
    },

    /**
     * パッケージ・商品一覧エリアを更新
     */
    updatePackageAndProductsArea: (isInit) => {

      // 初期化
      group1.packagesAndProductsDataExists = false
      group1.isListPackagesAndProductsLoaded = false
      group1.booksDataExists = false
      group1.isListBooksLoaded = false
      group1.documentDownloadsExists = false
      group1.isMatchedTotalLoaded = false

      // パッケージ・商品一覧APIをコール
      const params = {}
      params.is_trial = 0 // 0=通常
      params.is_only_contact = 1 // 1=契約商品のみ
      params.search_range = 2 // キーワード検索対象範囲(2=書式DL画面)
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword // キーワード
      }

      apiQA.listPackagesAndProductsForSearch(params)
        .then(response => {
          if (response) {
            const { data } = response

            const packages = data.packages ?? []
            const books = data.books ?? []

            // パッケージ＆商品データ存在フラグ
            group1.packagesAndProductsDataExists = (packages.length + books.length > 0)

            if (!group1.packagesAndProductsDataExists) {
              // パッケージ＆商品データが存在しない場合

              // 書籍一覧エリアを検索結果なしで表示する
              group1.isListBooksLoaded = true
              group1.booksDataExists = false

              // 書籍目次書式DL一覧エリアを更新
              group1.isListBooksAndFormDownloadsLoaded = true
              group1.documentDownloadsExists = false
              group1.booksDataExists = false
            } else {

              const treeData = {
                id: 0,
                name: '',
                packages: data.packages
              }

              // ツリーデータの全ノードにユニークなID(数値)を設定し直す
              const __param = { id: 10000 } // 分かりやすくpackage_id/product_id/book_idと被らないIDから始める
              common.addUniqueIdForTreeData(treeData, 'id', ['packages', 'products', 'books'], __param)
              treeData.id = 0 // ルートノードのidは必ず0
              
              // 全ノードの初期化
              const parentNodeMap = {}
              group1.initNodes(treeData, parentNodeMap)


              // 単体書籍一覧のisCheckedをfalseで初期化
              for (let i = 0; i < books.length; i++) {
                const searchCount = books[i].search_count
                books[i].search_count_disp = common.breakComma(searchCount)
                books[i].isChecked = false
                books[i].itemType = 'book'
              }

              if (isInit) {
                // init() から実行された場合

                if (Object.keys(store.state.documentDownloadsList.packagesAndProductsAreaTreeData).length !== 0) {
                  // init() から実行された場合でパッケージツリー情報がストアにある場合(別ページから戻ってきた場合)は、
                  // チェック状態を復元する

                  // 絞り込みツリーのチェックされているノードのitemTypeとIDのリストを取得する
                  const treeDataOfStore = store.state.documentDownloadsList.packagesAndProductsAreaTreeData
                  const checkedNodeItemTypeAndIds = []
                  getCheckedNodeItemTypeAndIds(treeDataOfStore, checkedNodeItemTypeAndIds)

                  // itemTypeとIDのリストにより、絞り込みツリーのチェック状態を設定する
                  setNodeCheckByItemTypeAndIds(treeData, checkedNodeItemTypeAndIds)
                }
                if (Object.keys(store.state.documentDownloadsList.packagesAndProductsAreaBooks).length !== 0) {
                  // init() から実行された場合で単体書籍情報がストアにある場合(別ページから戻ってきた場合)は、
                  // チェック状態を復元する

                  const booksOfStore = store.state.documentDownloadsList.packagesAndProductsAreaBooks

                  const singleBooksWork = []
                  for (let i = 0; i < books.length; i++) {
                    const productId = books[i].product_id
                    const bookId = books[i].book_id
                    for (let k = 0; k < booksOfStore.length; k++) {
                      if (booksOfStore[k].isChecked) {
                        const _productId = booksOfStore[k].product_id ?? 0
                        const _bookId = booksOfStore[k].book_id ?? 0
                        if (productId === _productId && bookId === _bookId) {
                          books[i].isChecked = true
                          singleBooksWork.push(productId + ',' + bookId)
                          break
                        }
                      }
                    }
                  }
                  group1.single_books = singleBooksWork
                }
              }

              group1.packagesAndProductsAreaTreeData = treeData
              group1.parentNodeMap = parentNodeMap
              group1.packagesAndProductsAreaBooks = books

              // 検索対象の商品IDのリスト
              const searchProductIds = []
              for (let i = 0; i < packages.length; i++) {
                for (let k = 0; k < packages[i].products.length; k++) {
                  const productId = packages[i].products[k].product_id
                  searchProductIds.push(productId)
                }
              }

              // 書籍一覧APIをコール
              // パッケージ・商品の絞り込みは、
              // パッケージor商品に所属する書籍IDをすべて書籍一覧APIに渡すことで、
              // 絞り込みを実施する。
              // そのためのパッケージ/商品 → 書籍IDリストの対応マップをここで生成する。
              const params = {}
              params.search_range = 2 // キーワード検索対象範囲「2=書式DL画面」
              params.product_ids = searchProductIds

              // 商品IDに対する全商品ID&書籍IDリストの対応マップを初期化
              const allIdMapListForProductIdMapWork = {}

              apiQA.listBooksForSearch(params)
                .then(response => {
                  if (response) {
                    const { data } = response

                    const products = data.products ?? []

                    for (let i = 0; i < products.length; i++) {
                      const productId = products[i].product_id

                      const idMapList = []
                      for (let k = 0; k < products[i].books.length; k++) {
                        const productId2 = products[i].books[k].product_id
                        const bookId2 = products[i].books[k].book_id
                        const map = {
                          product_id: productId2,
                          book_id: bookId2
                        }
                        idMapList.push(map)
                      }

                      // 商品IDに対する全書籍IDリストの対応マップを設定
                      const key = 'product_' + productId
                      allIdMapListForProductIdMapWork[key] = idMapList
                    }

                    group1.allIdMapListForProductIdMap = allIdMapListForProductIdMapWork
                  }
                })

              // 書籍一覧エリアを更新
              group1.updateBooksArea()
            }
          }
        })
        .finally(() => {
          group1.isListPackagesAndProductsLoaded = true
        })
    },

    /**
     * 書籍一覧エリアを更新
     */
    updateBooksArea: () => {

      group1.isListBooksLoaded = false

      // 書籍一覧APIをコール
      const params = {}
      params.search_range = 2 // キーワード検索対象範囲「2=書式DL画面」
      if (group1.idMapListOfCheckedProducts.length > 0) { // チェックなしの場合は絞り込まない
        params.product_books = group1.idMapListOfCheckedProducts // チェックされている書籍ID
      }
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword // キーワード
      }

      apiQA.listBooksForSearch(params)
        .then(response => {
          if (response) {
            const { data } = response
     
            const booksAreaProductsWork = data.products ?? []
            const books = data.books ?? []

            // 書籍データ存在フラグ
            group1.booksDataExists = (booksAreaProductsWork.length + books.length > 0)

            if (!group1.booksDataExists) {
              // 書籍データが存在しない場合

              // 書籍目次書式DL一覧エリアを更新
              group1.isListBooksAndFormDownloadsLoaded = true
              group1.documentDownloadsExists = false
              group1.booksDataExists = false
            } else {
           
              // 検索結果件数をカンマ区切りに加工
              for (let i = 0; i < books.length; i++) {
                const searchCount = books[i].search_count
                books[i].search_count_disp = common.breakComma(searchCount)
              }
              const booksAreaBooksWork = data.books ?? []

              let targetBookId = 0
              let targetBookName = ''
              let targetBookType = ''
              let targetNodeId = 0

              // 選択フラグ(書籍のハイライト表示フラグ)を追加する(フラグの初期化)
              for (let i = 0; i < booksAreaProductsWork.length; i++) {
                if (typeof booksAreaProductsWork[i].books !== 'undefined' && Array.isArray(booksAreaProductsWork[i].books)) {
                  for (let k = 0; k < booksAreaProductsWork[i].books.length; k++) {
                    const _nodeId = booksAreaProductsWork[i].books[k].id
                    const _productId = booksAreaProductsWork[i].books[k].product_id
                    const _bookId = booksAreaProductsWork[i].books[k].book_id
                    if (
                      store.state.documentDownloadsList.selectedIdMapOfBooksArea &&
                      _bookId === store.state.documentDownloadsList.selectedIdMapOfBooksArea.book_id
                    ) {
                      targetBookType = 'package_book'
                      targetNodeId = _nodeId
                      booksAreaProductsWork[i].books[k].isSelected = true

                      // 見つかった書籍IDと書籍名を設定
                      targetBookId = booksAreaProductsWork[i].books[k].book_id
                      targetBookName = booksAreaProductsWork[i].books[k].name
                    } else {
                      booksAreaProductsWork[i].books[k].isSelected = false
                    }
                  }
                }
              }
              for (let i = 0; i < booksAreaBooksWork.length; i++) {
                const _nodeId = booksAreaBooksWork[i].id
                const _productId = booksAreaBooksWork[i].product_id
                const _bookId = booksAreaBooksWork[i].book_id
                if (
                  store.state.documentDownloadsList.selectedIdMapOfBooksArea &&
                  _bookId === store.state.documentDownloadsList.selectedIdMapOfBooksArea.book_id
                ) {
                  targetBookType = 'single_book'
                  targetNodeId = _nodeId
                  booksAreaBooksWork[i].isSelected = true

                  // 見つかった書籍IDと書籍名を設定
                  targetBookId = booksAreaBooksWork[i].book_id
                  targetBookName = booksAreaBooksWork[i].name
                } else {
                  booksAreaBooksWork[i].isSelected = false
                }
              }

              if (targetBookId === 0) {
                // 対象の書籍が見つからなかった場合

                // 初期表示の場合は、最初の書籍の目次を表示する
                if (
                  booksAreaProductsWork && booksAreaProductsWork.length > 0 &&
                  booksAreaProductsWork[0].books && booksAreaProductsWork[0].books.length > 0
                ) {
                  // 目次を表示中の書籍の種類
                  targetBookType = 'package_book'
                  // 目次を表示中のノードID
                  targetNodeId = booksAreaProductsWork[0].books[0].id ?? 0
                  // 最初の書籍の書籍IDを設定
                  targetBookId = booksAreaProductsWork[0].books[0].book_id ?? 0
                  // 最初の書籍の書籍名を設定
                  targetBookName = booksAreaProductsWork[0].books[0].name ?? ''
                  // 最初の書籍をハイライト表示
                  booksAreaProductsWork[0].books[0].isSelected = true
                } else if (
                  booksAreaBooksWork && booksAreaBooksWork.length > 0
                ) {
                  // 目次を表示中の書籍の種類
                  targetBookType = 'single_book'
                  // 目次を表示中のノードID
                  targetNodeId = booksAreaBooksWork[0].id ?? 0
                  // 最初の書籍の書籍IDを設定
                  targetBookId = booksAreaBooksWork[0].book_id ?? 0
                  // 最初の書籍の書籍名を設定
                  targetBookName = booksAreaBooksWork[0].name ?? ''
                  // 最初の書籍をハイライト表示
                  booksAreaBooksWork[0].isSelected = true
                }
              }

              group1.booksAreaProducts = booksAreaProductsWork
              group1.booksAreaBooks = booksAreaBooksWork

              if (targetBookId !== 0) {
                // 書式DL一覧エリアを表示
                group1.updateDocumentDownloadsArea(targetBookId, targetBookName, true)
              } else {
                store.dispatch('common/showNotice', { title: 'エラー', text: '書籍目次データが取得できませんでした。' })
              }
            }
          }
        })
        .finally(() => {
          group1.isListBooksLoaded = true
        })
    },

    /**
     * 書籍目次書式DL一覧エリアを更新
     * @param {string} targetBookType 対象書籍の書籍の種類(package_book=パッケージ商品、single_book=単体書籍)
     * @param {number} targetNodeId 対象書籍のノードID
     * @param {number} targetBookId 対象書籍の書籍ID
     * @param {number} targetBookName 対象書籍の書籍名
     * @param {number} moveToFirstHighlight キーワード検索のハイライトがある場合に
     *                                最初のハイライトの位置に移動する場合true、
     *                                最後のハイライトの位置に移動する場合はfalse
     *                                ハイライトが存在しない場合は無効
     */
    updateDocumentDownloadsArea: (targetBookId, targetBookName, moveToFirstHighlight = true) => {

      // 目次を表示中の書籍のIDを設定
      group1.currentBookId = targetBookId
      group1.currentBookName = targetBookName

      if (targetBookId === 0) {
        // 書籍IDが未指定の場合
        return
      }

      group1.isListBooksAndFormDownloadsLoaded = false

      // 対象書籍より前までの書籍のキーワード件数の合計（対象書籍の開始番号）と全合計を取得する
      const { matchedCountBefore, matchedTotal } = logicCommonBookList.getMatchedCountBeforeAndMmatchedTotal(targetBookId, group1)
      group1.matchedTotal = matchedTotal
      
      // 書籍目次書式DL一覧APIをコール
      const params = {}
      params.book_id = targetBookId
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword
      }

      apiQA.listBooksAndFormDownloads(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 書式DL一覧ツリーデータ存在フラグ
            group1.documentDownloadsExists = (data.list.length > 0)

            const listWork = data.list

            const treeData = {
              id: 0,
              name: '',
              children: listWork
            }

            // ツリーの要素に拡張項目を追加する
            group1.addExtraParamsToTreeData(treeData, null)

            // ハイライト処理
            // ツリーデータのキーワード存在フラグが1のノードに対して前から順番に番号を付与していく
            group1.matchedStartNo = matchedCountBefore + 1
            const __param = {}
            __param.no = group1.matchedStartNo // 開始番号
            group1.addMatchedNo(treeData, __param)
            group1.matchedEndNo = __param.no - 1 // 終了番号
            // 現在の番号を開始番号に設定
            group1.matchedCurrentNo = group1.matchedStartNo

            // ツリーデータを設定
            group1.documentDownloadsAreaTreeData = treeData

            Vue.nextTick(() => {
              // 現在のマッチキーワードがあれば移動
              const matchedNo = moveToFirstHighlight ? group1.matchedStartNo : group1.matchedEndNo
              const target = document.getElementById('matched_' + matchedNo)
              if (target) {
                target.scrollIntoView({block: 'center', behavior: 'auto'})
              }
            })

          }
        })
        .finally(() => {
          group1.isListBooksAndFormDownloadsLoaded = true
        })

      // キーワード検索結果件数取得APIをコール
      const countParams = {}
      countParams.search_range = 2 // 検索対象：2=書式DL画面
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        countParams.search_text = group1.lastSearchedKeyword
        if (group1.idMapListOfCheckedProducts.length > 0) {
          // 絞り込みをしている場合
          countParams.product_books = group1.idMapListOfCheckedProducts
        }
      } else {
        // キーワードが入力されてない場合（初期表示、検索をクリア）
        // 絞り込みをしていない場合は、現在表示している書籍に属する書式数
        if (group1.currentBookId !== 0) {
          countParams.book_ids = common.toArray(group1.currentBookId)
        }
      }

      // データ件数ロード完了フラグをfalseに設定
      group1.isMatchedTotalLoaded = false

      apiQA.countKeywordSearchResults(countParams)
        .then(r => {
          const data = r.data
          if (data.status === 0) {
            group1.matchedTotal = data.count
          }
        })
        .finally(() => {
          group1.isMatchedTotalLoaded = true
        })

    },

    /**
     * 検索キーワードをスペースで分割した配列
     */
    searchTextList: computed(() => {
      // キーワードにマッチした箇所がすべてハイライト表示されるように、
      // キーワードを文字列の長い順に並び替える。
      // （短いキーワードで先にreplaceすると長いキーワードの置換ができなくなるため）
      const searchText = store.state.searchUI.params.download_search_text_input
      const searchText2 = searchText.replace(/　/g, ' ') // 全角スペースを半角スペースに置換
      const list = searchText2.split(' ') // 半角スペースで分割
      const list2 = []
      for (let i = 0; i < list.length; i++) {
        if (list[i] !== '') {
          list2.push(list[i])
        }
      }
      list2.sort((a, b) => { return b.length - a.length })
      return list2
    }),

    /**
     * ツリーの要素に拡張項目を追加する
     */
    addExtraParamsToTreeData: (node, parentNode) => {
      // 書式DLの場合は、全ノードをオープンにする
      node.isOpen = true
      node.parent = parentNode

      // タイトルが改行されている場合は、1行目の文字列と、2行目以降の文字列のリストに分離する
      const title = node.title
      let titleFirstLine = ''
      const titleAfterSecondLines = []
      if (typeof title !== 'undefined') {
        const arr = title.split(/\r?\n/)
        for (let i = 0; i < arr.length; i++) {
          if (i === 0) {
            titleFirstLine = arr[i]
          } else {
            titleAfterSecondLines.push(arr[i])
          }
        }
      }

      if (group1.isKeywordSearch) {
        // キーワード検索実行中の場合
        if (typeof node.format_list !== 'undefined') {
          // const searchTextList = store.state.documentDownloadsList.search_text_list
          const searchTextList = group1.searchTextList
          const fromatList = node.format_list ?? []
          for (let i = 0; i < fromatList.length; i++) {
            let formatName = fromatList[i].format_name
            // 書式名でキーワードに一致する箇所をハイライト表示する
            for (let k = 0; k < searchTextList.length; k++) {
              if (searchTextList[k] !== '') {
                formatName = formatName.replace(searchTextList[k], '<em class="matched">' + searchTextList[k] + '</em>')
              }
            }
            fromatList[i].format_name = formatName
          }
          node.format_list = fromatList
        }
      }

      node.title_first_line = titleFirstLine
      node.title_after_second_lines = titleAfterSecondLines

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.addExtraParamsToTreeData(node.children[i], node)
        }
      }
    },

    /**
     * ツリーデータのキーワード存在フラグが1の書式に対して前から順番に番号を付与していく
     * 用途：キーワードの存在する書式にid="match_result_{番号}"属性を付与し、
     * 前へ、次へボタン押下の移動で使用する
     * @param {object} node ツリーデータ
     * @param {object} __param 番号 (JSはプリミティブ型の参照渡しができないのでオブジェクトを使って参照渡しをする)
     */
    addMatchedNo: (node, __param = null) => {

      // 書式に対して番号を付与する
      if (typeof node.format_list !== 'undefined') {
        for (let i = 0; i < node.format_list.length; i++) {
          if (node.format_list[i].keyword_exists === 1) {
            node.format_list[i].matched_no = __param.no
            node.format_list[i].matched_no_disp = common.breakComma(__param.no)
            __param.no++
          }
        }
      }
    
      const key = 'children'
      if (typeof node[key] !== 'undefined' && Array.isArray(node[key])) {
        for (let i = 0; i < node[key].length; i++) {
          const childData = node[key][i]
          group1.addMatchedNo(childData, __param)
        }
      }  
    }, 

    /**
    * 全ノードの初期化
    */
    initNodes: (node, parentNodeMap, parentNode = null) => {

      node.isChecked = false

      let parentNodeMapKey = ''
      if (typeof node.package_id !== 'undefined') {
        node.itemType = 'package'
        parentNodeMapKey = 'package_' + node.package_id
      } else if (typeof node.product_id !== 'undefined') {
        node.itemType = 'product'
        parentNodeMapKey = 'product_' + node.product_id
      }
      parentNodeMap[parentNodeMapKey] = parentNode

      if (typeof node.packages !== 'undefined') {
        for (let i = 0; i < node.packages.length; i++) {
          group1.initNodes(node.packages[i], parentNodeMap, node)
        }
      }
      if (typeof node.products !== 'undefined') {
        for (let i = 0; i < node.products.length; i++) {
          group1.initNodes(node.products[i], parentNodeMap, node)
        }
      }
    },

    /**
     * 絞り込みツリーの全ノードのチェック状態を設定
     */
    setAllNoodesCheck: (node, isChecked) => {
      node.isChecked = isChecked
      if (typeof node.packages !== 'undefined') {
        for (let i = 0; i < node.packages.length; i++) {
          group1.setAllNoodesCheck(node.packages[i], isChecked)
        }
      }
      if (typeof node.products !== 'undefined') {
        for (let i = 0; i < node.products.length; i++) {
          group1.setAllNoodesCheck(node.products[i], isChecked)
        }
      }
    },

    /**
     * 検索を実行する
     * 用途：検索ボタン押下時
     */
    search: () => {
      const options = {}
      group1.searchWithOptions(options)
    },

    /**
     * 検索を実行する（オプション指定）
     */
    searchWithOptions(options) {

      let searchCategory
      let searchText
      let isFuzzy
      if (
        typeof options !== 'undefined' &&
        typeof options.searchCategory !== 'undefined'
      ) {
        searchCategory = options.searchCategory
        searchText = options.search_text
        isFuzzy = options.is_fuzzy
      } else {
        searchCategory = group1.searchCategory
        searchText = group1.search_text
        isFuzzy = group1.is_fuzzy
      }

      if (searchCategory !== 'download') {
        // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
        searchByKeyword(context, searchCategory, searchText, isFuzzy) 
        return
      }

      // 初期化
      group1.isListPackagesAndProductsLoaded = false
      group1.isListBooksLoaded = false
      group1.isListBooksAndFormDownloadsLoaded = false

      // init()から実行されたか
      let isInit = false
      if (typeof options.is_init !== 'undefined') {
        isInit = options.is_init
      }

      // 同画面でキーワード検索が実行されたか？
      // (1)キーワード入力欄でEnterを押した
      // (2)キーワード入力欄の検索ボタンを押した場合
      // ※他の画面から遷移してきた場合はfalse
      let isSearchExecutedAtSameScreen = false
      if (typeof options.search_executed !== 'undefined') {
        isSearchExecutedAtSameScreen = options.search_executed
      }

      // 検索カテゴリを設定（init()で設定されると思うが念のため設定）
      store.dispatch('search/setSearchCategory', 'download')

      if (isSearchExecutedAtSameScreen) {
        // 同画面での検索の場合

        // 絞り込みのチェックをすべてクリア
        // パッケージ商品
        const treeData = group1.packagesAndProductsAreaTreeData
        group1.setAllNoodesCheck(treeData, false)
        group1.packagesAndProductsAreaTreeData = treeData
        // 単体書籍
        group1.single_books = []
        group1.packagesAndProductsAreaBooks = [] 
        // ストアに保持している絞り込み情報をクリア
        store.dispatch('documentDownloadsList/setPackagesAndProductsAreaTreeData', {})
        store.dispatch('documentDownloadsList/setPackagesAndProductsAreaBooks', [])
        store.dispatch('documentDownloadsList/setIdMapListOfCheckedProducts', [])
      }

      // 最後に検索実行したキーワードを設定
      group1.lastSearchedKeyword = searchText

      // 検索条件をストアに保持
      const searchParams = {
        search_text: searchText
      }
      store.dispatch('search/setDownloadSearchParam', searchParams)

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // パッケージ・商品一覧、書籍一覧、書籍目次一覧を検索する処理
      group1.updatePackageAndProductsArea(isInit)
    },

    /**
     * 検索をクリア
     */
    clearSearch: () => {

      // 初期化
      group1.isListPackagesAndProductsLoaded = false
      group1.isListBooksLoaded = false 
      group1.isListBooksAndFormDownloadsLoaded = false
      group1.matchedTotal = 0
      group1.isMatchedTotalLoaded = false

      // 各検索条件をクリア
      group1.packagesAndProductsAreaTreeData = {}
      group1.single_books = []
      group1.lastSearchedKeyword = ''

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: group1.searchCategory, searchText: '', isFuzzy: 0 })

      // ストアに保持している検索条件をクリア
      store.dispatch('search/setDownloadSearchParam', {})

      // ストアに保持している絞り込み情報をクリア
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaTreeData', {})
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaBooks', [])
      store.dispatch('documentDownloadsList/setIdMapListOfCheckedProducts', [])

      // モードを「list: 一覧表示(ドリルダウン)モード」に設定
      group1.mode = 'list'

      // パッケージ・商品一覧、書籍一覧、書籍目次一覧を検索する処理
      group1.updatePackageAndProductsArea(true)
    },

    /**
     * 目次をすべて開く
     * 用途：目次一覧エリアの「すべて開く」ボタン押下時
     */
    openAllTableOfContents: () => {
    },

    /**
     * 目次を全て閉じる
     * 用途：目次一覧エリアの「すべて閉じる」ボタン押下時
     */
    closeAllTableOfContents: () => {
    },

    /**
     * チェックされた商品の商品ID&書籍IDリスト検出し、
     * 変数group1.idMapListOfCheckedProductsに設定する
     */
    setIdMapListOfCheckedProducts: () => {

      const idMapListOfCheckedProducts = []

      // パッケージ＆商品ツリーでチェックされている商品の商品IDリスト
      const checkedProductIds = []
      const treeData = group1.packagesAndProductsAreaTreeData
      getCheckedProductIds(treeData, checkedProductIds)

      // 商品IDに対する全商品ID＆書籍IDリスト
      for (let i = 0; i < checkedProductIds.length; i++) {
        const key = 'product_' + checkedProductIds[i]
        if (typeof group1.allIdMapListForProductIdMap[key] !== 'undefined') {
          const idMapList = group1.allIdMapListForProductIdMap[key]
          for (let k = 0; k < idMapList.length; k++) {
            idMapListOfCheckedProducts.push(idMapList[k])
          }
        }
      }

      // 単体書籍リストでチェックされている書籍の書籍IDリストを取得し、リストに追加
      const idsOfSingleBooks = group1.single_books
      for (let i = 0; i < idsOfSingleBooks.length; i++) {
        if (idsOfSingleBooks[i] !== '') {
          const arr = idsOfSingleBooks[i].split(',')
          const productId = Number(arr[0]) ?? 0
          const bookId = Number(arr[1]) ?? 0
          const map = {
            product_id: productId,
            book_id: bookId
          }
          idMapListOfCheckedProducts.push(map)
        }
      }

      // group1.idMapListOfCheckedProducts = idMapListOfCheckedProducts

      // ストアに保存
      store.dispatch('documentDownloadsList/setIdMapListOfCheckedProducts', idMapListOfCheckedProducts)
    },

    /**
     * パッケージ＆商品一覧ツリーのいずれかのチェックボックスがチェックされた場合
     */
    onPackageAndProductsTreeItemClicked: ({nodeId, targetIdsMap}) => {

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // 絞り込みツリー：チェック状態を伝播させる
      const treeData = group1.packagesAndProductsAreaTreeData 
      propagateCheckedRecursively(treeData, nodeId, group1.parentNodeMap)

      // パッケージ商品、単体書籍の絞り込みチェック状態をストアに保存する
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaTreeData', treeData)
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaBooks', group1.packagesAndProductsAreaBooks)

      // チェックされた商品の商品ID＆書籍IDリストを設定する
      group1.setIdMapListOfCheckedProducts()

      // 書籍一覧、書籍目次一覧を検索する処理
      group1.updateBooksArea()
    },

    /**
     * 単体書籍リストのいずれかのチェックボックスがチェックされた場合
     */
    onSingleBookClicked: () => {

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // 絞り込みのチェック状態を設定
      const idsOfSingleBooks = group1.single_books
      const books = group1.packagesAndProductsAreaBooks
      for (let i = 0; i < books.length; i++) {
        const productId = books[i].product_id
        const bookId = books[i].book_id
        let isFound = false
        for (let k = 0; k < idsOfSingleBooks.length; k++) {
          if (idsOfSingleBooks[k] !== '') {
            const arr = idsOfSingleBooks[k].split(',')
            const _productId = Number(arr[0]) ?? 0
            const _bookId = Number(arr[1]) ?? 0
            if (productId === _productId && bookId === _bookId) {
              isFound = true
              break
            }
          }
        }
        books[i].isChecked = isFound
      }
      group1.packagesAndProductsAreaBooks = books

      // パッケージ商品、単体書籍の絞り込みチェック状態をストアに保存する
      const treeData = group1.packagesAndProductsAreaTreeData 
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaTreeData', treeData)
      store.dispatch('documentDownloadsList/setPackagesAndProductsAreaBooks', group1.packagesAndProductsAreaBooks)

      // チェックされた商品の商品ID＆書籍IDリストを設定する
      group1.setIdMapListOfCheckedProducts()

      // 書籍一覧、書籍目次一覧を検索する処理
      group1.updateBooksArea()
    },

    /**
     * 書籍を選択した場合
     * @param {string} bookType 書籍の種類(package_book=パッケージ商品、single_book=単体書籍)
     * @param {number} nodeId ツリー用ID
     */
    selectBook: (bookType, nodeId, productId, bookId, bookName) => {

      // 目次を表示中の書籍のIDを設定
      group1.currentBookId = bookId
      group1.currentBookName = bookName
      
      // store保持項目の設定
      store.dispatch('qa/setBookId', bookId)
      store.dispatch('qa/setBookName', bookName)
      store.dispatch('qa/setQaId', 0)
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setNumberCarouselVisible', 0)

      // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)を保持
      const selectedIdMap = {
        product_id: productId,
        book_id: bookId
      }
      store.dispatch('documentDownloadsList/setSelectedIdMapOfBooksArea', selectedIdMap)

      // 書籍エリアのハイライトを設定
      logicCommonBookList.setHighlightedItemInBooksArea(bookType, nodeId, group1)

      // 書式DL一覧エリアを更新
      group1.updateDocumentDownloadsArea(bookId, bookName, true)
    }

  })

  const searchSelect = reactive({
    isFocusInput: false,
    currentValue: 0
  })

  return {
    group1,
    searchSelect
  }
}
